import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import "./styles.css";
import GestionSecteur from "../../components/GestionSecteur";
import logo from "../../assets/logo.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars, faBell, faRightFromBracket, faShare, faXmark } from "@fortawesome/free-solid-svg-icons";
import { logout } from "../../redux/actions/authActions";
import GestionOffers from "../../components/GestionOffers";
import { prestataires } from "../../datas/prestataires";
import GestionPrestatairesToValidate from "../../components/GestionPrestatairesToValidate";
import GestionCgu from "../../components/GestionCgu";
import { setActiveSection } from "../../redux/actions/dashboardActions";
import NotificationsDashboard from "../../components/NotificationsDashboard";
import logoutIcon from "../../assets/logout.png";
import ShareModal from "../../components/ShareModal";
import UsersInscritsDashboard from "../../components/UsersInscritsDashboard";
import Cgu from "../../components/Cgu";
import ProjetsClientsAdminDashboard from "../../components/ProjetsClientsAdminDashboard";
import Factures from "../../components/Factures";
import MaPagePublicite from "../../components/MaPagePublicite";

// Tu pourras ajouter d’autres composants comme ChiffresAffaires, Clients, etc.

const AdminDashboard = () => {
  const { user: authUser, token } = useSelector((state) => state.auth);
  const navigate = useNavigate();
  const { activeSection } = useSelector(state => state.dashboard);
  const dispatch = useDispatch();
  const [menuOpen, setMenuOpen] = useState(false);
  const [showShareModal, setShowShareModal] = useState(false);
  const notifications = useSelector((state) => state.notification?.list || []); // non-lues si ton API renvoie que non-lues
  const unreadCount = notifications.length;
  const handleLogout = () => {
    dispatch(logout());
    navigate("/");
  };
  useEffect(() => {
    if (!authUser) navigate("/");
  }, [authUser, navigate]);
  useEffect(() => {
    if (activeSection === "")
      dispatch(setActiveSection("clients"));
  }, [activeSection, dispatch]);
  const openNotifications = () => {
    dispatch(setActiveSection("notifications"));
    setMenuOpen(false);
  };
  // Mapping des sections disponibles
  const sections = {
    secteurs: <GestionSecteur />,
    ia: <MaPagePublicite/>,
    offres: <GestionOffers />,
    cgu: <Cgu />,
    projetsClients: <ProjetsClientsAdminDashboard />,
    prestatairesToValidate: <GestionPrestatairesToValidate />,
    ca: <div><h2>Chiffres d'affaires</h2><p>Statistiques et graphiques ici…</p></div>,
    clients: <UsersInscritsDashboard />,
    notifications: <NotificationsDashboard />,
    facturesPlateforme: <Factures />
    // tu ajoutes d’autres écrans au besoin
  };

  const downloadFactures = async (annee, mois) => {


    const params = new URLSearchParams({ annee });
    if (mois) params.append("mois", mois);

    const response = await fetch(
      `${process.env.REACT_APP_API_URL}/api/factures/export?${params}`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        }
      }
    );

    if (!response.ok) {
      alert("Erreur lors du téléchargement");
      return;
    }

    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);

    const a = document.createElement("a");
    a.href = url;
    a.download = `factures_${annee}${mois ? "_" + mois : ""}.pdf`;
    document.body.appendChild(a);
    a.click();
    a.remove();

    window.URL.revokeObjectURL(url);
  };


  const [nbVisits, setNbVisits] = useState(0);
  const [nbTotalVisits, setNbTotalVisits] = useState(0);
  const apiUrl = process.env.REACT_APP_API_URL;

  useEffect(() => {
    const getVisitsDay = async () => {
      try {
        const response = await fetch(
          `${apiUrl}/api/visit/today`,
          {
            method: "GET",
          }
        );

        if (!response.ok) {
          throw new Error(`HTTP ${response.status}`);
        }

        const data = await response.json();

        console.log("Visites du jour :", data);

        setNbVisits(data.nbVisits ?? 0);
      } catch (error) {
        console.error("Erreur récupération visites du jour :", error);
      }
    };

    const getVisits = async () => {
      try {
        const response = await fetch(
          `${apiUrl}/api/visit/total`,
          {
            method: "GET",
          }
        );

        if (!response.ok) {
          throw new Error(`HTTP ${response.status}`);
        }

        const data = await response.json();

        console.log("Visites totales :", data);

        setNbTotalVisits(data.nbVisits ?? data.nbTotalVisits ?? 0);
      } catch (error) {
        console.error("Erreur récupération visites totales :", error);
      }
    };

    getVisitsDay();
    getVisits();

    const interval = setInterval(() => {
      getVisitsDay();
      getVisits();
    }, 20 * 1000);

    return () => clearInterval(interval);
  }, [apiUrl]);
  return (
    <main className="client-dashboard">
      {/* Menu latéral ou top selon device */}
      <nav className={`client-menu ${menuOpen ? "open" : ""}`}>
        {/* HEADER MOBILE : logo + hamburger */}
        <div className="mobile-header">
          <img src={logo} alt="Logo Intereseaux" className="logo-mobile" />

          <div className="mobile-top-icons">
            <button
              className="icon-btn notif-btn-mobile"
              onClick={openNotifications}
              aria-label="Notifications"
            >
              <FontAwesomeIcon icon={faBell} />
              {unreadCount > 0 && <span className="notif-badge-mobile">{unreadCount}</span>}
            </button>
            <button style={{ background: "transparent", padding: 0, border: "none" }}>
              <FontAwesomeIcon className="icon-btn notif-btn-mobile"
                icon={faShare} style={{ background: "transparent" }} onClick={() => setShowShareModal(true)}
                aria-label="Partager" />
            </button>

            <button
              className="icon-btn hamburger-btn"
              onClick={() => setMenuOpen((s) => !s)}
              aria-expanded={menuOpen}
              aria-label="Ouvrir le menu"
            >
              <FontAwesomeIcon icon={menuOpen ? faXmark : faBars} />
            </button>
          </div>
        </div>

        {/* DESKTOP LOGO */}
        <div className="logo-desktop">
          <a href="/espace-prestataire">
            <img src={logo} alt="Logo Intereseaux" className="logo-dashboard-img" />
          </a>
        </div>

        {/* DESKTOP BELL (centered under logo) */}
        <div className="notif-desktop-wrapper">
          <button className="icon-btn notif-btn-desktop" onClick={openNotifications} aria-label="Notifications">
            <FontAwesomeIcon icon={faBell} shake={unreadCount > 0} />
            {unreadCount > 0 && <span className="notif-badge-desktop">{unreadCount}</span>}
          </button>
        </div>
        <div className="notif-desktop-wrapper">
          <button className="icon-btn notif-btn-desktop" onClick={openNotifications} aria-label="Partager">
            <FontAwesomeIcon icon={faShare} onClick={() => setShowShareModal(true)} onClose={() => setShowShareModal(false)} />

          </button>
        </div>


        <ul className="menu-items">
          <li
            className={activeSection === "secteurs" ? "active" : ""}
            onClick={() => { dispatch(setActiveSection("secteurs")); setMenuOpen(false); }}
          >
            Gestion Secteurs & Métiers
          </li>
          <li
            className={activeSection === "offres" ? "active" : ""}
            onClick={() => { dispatch(setActiveSection("offres")); setMenuOpen(false); }}
          >
            Gestion des offres
          </li>
          <li className={activeSection === "ia" ? "active" : ""} onClick={()=>{dispatch(setActiveSection("ia"));setMenuOpen(false);}}>
            ASSISTANT IA
          </li>
          <li
            className={activeSection === "cgu" ? "active" : ""}
            onClick={() => { dispatch(setActiveSection("cgu")); setMenuOpen(false); }}
          >
            Consulter les CGU
          </li>
          <li
            className={activeSection === "projetsClients" ? "active" : ""}
            onClick={() => { dispatch(setActiveSection("projetsClients")); setMenuOpen(false); }}
          >
            Projets clients
          </li>
          <li
            className={activeSection === "prestatairesToValidate" ? "active" : ""}
            onClick={() => { dispatch(setActiveSection("prestatairesToValidate")); setMenuOpen(false); }}
          >
            Prestataires en attente de validation
          </li>
          <li
            className={activeSection === "ca" ? "active" : ""}
            onClick={() => { dispatch(setActiveSection("ca")); setMenuOpen(false); }}
          >
            Chiffres d'affaires
          </li>
          <li
            className={activeSection === "clients" ? "active" : ""}
            onClick={() => { dispatch(setActiveSection("clients")); setMenuOpen(false); }}
          >
            Utilisateurs
          </li>
          <li
            className={activeSection === "facturesPlateforme" ? "active" : ""}
            onClick={() => { dispatch(setActiveSection("facturesPlateforme")); setMenuOpen(false); }}
          >
            Factures INTERESEAUX
          </li>
          <li>
            <button className="logout-btn" onClick={handleLogout}>
              <img style={{ width: "30px", height: "30px", objectFit: "contain" }} src={logoutIcon} alt="icone logout" />
            </button>
          </li>
        </ul>

      </nav>

      {/* Zone de contenu */}
      <section className="admin-content">
        <div style={{display:"flex",width:"100%",justifyContent:"space-between"}}><div style={{textAlign:"center"}}><p>Nb de visiteurs du jour</p> <p>{nbVisits}</p> </div><div style={{textAlign:"center"}}><p>Nb de visiteurs total</p><p>{nbTotalVisits}</p></div> </div>
        {sections[activeSection]}
      </section>
      {showShareModal && <ShareModal shareUrl="https://intereseaux.com" onClose={() => setShowShareModal(false)} />}
    </main>
  );
};

export default AdminDashboard;
